import { SidebarItemConfig } from '../../types/sidebarItemConfig';

export interface SidebarItemsSlotProps {
  items: SidebarItemConfig[];
  shouldShowExpanded: boolean;
  isMobile: boolean;
  onToggleOpen: () => void;
}

export function SidebarItemsSlot({
  items,
  shouldShowExpanded,
  isMobile,
  onToggleOpen,
}: Readonly<SidebarItemsSlotProps>) {
  return (
    <>
      {items.map(({ id, component: Component, props, requiresOpen }) => {
        if (requiresOpen && !shouldShowExpanded) {
          return null;
        }

        return (
          <Component
            key={id}
            {...props}
            isOpen={shouldShowExpanded}
            onNavigate={isMobile ? onToggleOpen : undefined}
          />
        );
      })}
    </>
  );
}
